<template>
    <form
        v-if="isUpdateRequired && hasService"
        method="POST"
        enctype="multipart/form-data"
        :action="updateUri"
    >
        <input type="hidden" name="_token" :value="config.token">
        <input type="hidden" name="orderId" :value="config.orderId">

        <modal
            ref="modal"
            id="update-subscription"
            size="modal-lg"
            :title="$t('subscription.modalTitle')"
            :centered="true"
            :scrollable="true"
            :show="modal.show"
            :close="modal.hide"
            :closeable="modal.closeable"
            :tighter-close-button="true"
            @modal-opening="onModalStatusUpdate(true)"
            @modal-close="onModalStatusUpdate(false)"
        >
            <div class="modal-body">
                <p class="mb-0" v-html="$t(config.modalText)"></p>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" :disabled="ongoing" @click.prevent="hide">
                    <span v-html="$t('frontend.abort')"></span>
                </button>

                <button
                    type="submit"
                    style="font-size: 1rem"
                    class="btn btn-primary btn-sm"
                    :disabled="ongoing"
                    @click="ongoing = true"
                >
                    <i v-if="ongoing" class="mdi mdi-loading mdi-spin" style="margin-right: 5px"></i>
                    <span v-html="$t('subscription.updateBtn')"></span>
                </button>
            </div>
        </modal>
    </form>
</template>

<script>
export default {
    props: {
        config: {
            type: [
                Array,
                Object,
            ],
            required: true,
            default() {
                return {
                    show: false,
                    service: null,
                    token: null,
                    id: null,
                    orderId: null,
                    modalText: '',
                };
            },
        },
    },

    data() {
        return {
            modal: {
                show: false,
                hide: false,
                closeable: true,
            },
            ongoing: false,
        };
    },

    computed: {
        /**
         * @returns {boolean}
         */
        isUpdateRequired() {
            return typeof this.config.show === 'boolean' && this.config.show;
        },

        /**
         * @returns {boolean}
         */
        hasService() {
            return typeof this.config.service === 'string' && this.config.service.length > 0;
        },

        /**
         * @returns {string}
         */
        updateUri() {
            return `/${this.$language}/backend/payment/subscription-update/${this.config.id}`;
        },
    },

    methods: {
        /**
         * @returns {void}
         */
        show() {
            this.modal.hide = false;
            this.modal.show = this.modal.closeable = true;
        },

        /**
         * @returns {void}
         */
        hide() {
            if (!this.modal.closeable) {
                return;
            }

            this.modal.show = false;
            this.modal.hide = true;
        },

        /**
         * @param {boolean} open
         *
         * @returns {void}
         */
        onModalStatusUpdate(open) {
            if (!open) {
                this.$el.ownerDocument.body.classList.remove('overflow-hidden');
                this.hide();

                return;
            }

            this.$el.ownerDocument.body.classList.add('overflow-hidden');
        },
    },

    /**
     * @returns {void}
     */
    mounted() {
        if (!this.isUpdateRequired || !this.hasService) {
            return;
        }

        this.$nextTick(() => {
            this.show();
        });
    },
};
</script>
